module.exports = __webpack_public_path__ + "img/teams-big-user.412e6312.svg";